import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import { FiCheckCircle } from "react-icons/fi";
import styles from "./ExamSubmitModal.module.css";

const ExamSubmitModal = ({ isOpen, title, message, confirmText, cancelText, onConfirm, onCancel, showCancel = true }) => {
  const { t } = useTranslation();
  if (!isOpen) return null;
  const confirmLabel = confirmText ?? t("common.confirm");
  const cancelLabel = cancelText ?? t("common.close");

  const content = (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <div className={styles.iconWrap}>
            <FiCheckCircle className={styles.icon} aria-hidden />
          </div>
          {title && <h3 className={styles.title}>{title}</h3>}
        </div>

        {message && <p className={styles.message}>{message}</p>}

        <div className={styles.actions}>
          {showCancel && (
            <button type="button" className={styles.cancelButton} onClick={onCancel}>
              {cancelLabel}
            </button>
          )}
          <button type="button" className={styles.primaryButton} onClick={onConfirm}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );

  return createPortal(content, document.body);
};

export default ExamSubmitModal;
